import { XIcon } from "lucide-react"
import { Badge } from "~/components/ui/badge"
import { Button } from "~/components/ui/button"
import { ColorSwatch } from "~/components/ui/color-swatch"

export function RoleBadge({
	role,
	onRemove,
	removeLabel,
	disabled,
	variant = "outline"
}: {
	role: { name: string; color: string }
	onRemove?: () => void
	removeLabel?: string
	disabled?: boolean
	variant?: "outline" | "chip"
}) {
	return (
		<Badge
			variant={variant === "chip" ? "secondary" : "outline"}
			style={
				variant === "outline"
					? { borderColor: role.color, color: role.color }
					: undefined
			}
		>
			{onRemove ? (
				<Button
					type="button"
					variant="none"
					size="icon-2xs"
					shape="pill"
					className="group relative"
					disabled={disabled}
					onClick={onRemove}
					aria-label={removeLabel ?? `Remove ${role.name}`}
					title={`Remove ${role.name}`}
				>
					<ColorSwatch color={role.color} size="md" />
					<XIcon className="absolute size-2.5 text-background opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" />
				</Button>
			) : variant === "chip" ? (
				<ColorSwatch color={role.color} />
			) : null}
			{role.name}
		</Badge>
	)
}
